var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "max-width" },
    [
      _c(
        "Subheader",
        { attrs: { dense: "", title: "File Metadata" } },
        [
          _vm.edit
            ? _c(
                "v-btn",
                {
                  attrs: { color: "add", small: "" },
                  on: { click: _vm.onAddField },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                  _vm._v("\n      " + _vm._s(_vm.$t("Button.Add")) + "\n    "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              !_vm.edit
                ? [
                    _c("v-flex", { attrs: { xs4: "" } }, [_vm._v("File Type")]),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs8: "" } }, [
                      _vm._v(
                        _vm._s(_vm.schema != null ? _vm.schema.Name : "Generic")
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.edit
                ? [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            box: "",
                            label: "File Type",
                            items: _vm.schemaOptions,
                          },
                          on: { input: _vm.emitSchemaSelect },
                          model: {
                            value: _vm.formSchemaId,
                            callback: function ($$v) {
                              _vm.formSchemaId = $$v
                            },
                            expression: "formSchemaId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              !_vm.edit
                ? _vm._l(_vm.formMetadataFields, function (field, index) {
                    return _c(
                      "v-flex",
                      { key: field.Id, attrs: { xs12: "" } },
                      [
                        _c("FieldKeyMatcher", {
                          attrs: { index: index, field: field },
                        }),
                      ],
                      1
                    )
                  })
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "rdrFileMetadata" },
                        [
                          _c("DatasetFileMetadataInputs", {
                            ref: "metadata-inputs",
                            attrs: {
                              schema: _vm.schema,
                              "hide-add-button": "",
                            },
                            on: {
                              input: _vm.emitMetadataInput,
                              validate: function ($event) {
                                return _vm.validateMetadata($event)
                              },
                            },
                            model: {
                              value: _vm.formMetadataFields,
                              callback: function ($$v) {
                                _vm.formMetadataFields = $$v
                              },
                              expression: "formMetadataFields",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }